import { ComponentPortal } from "@angular/cdk/portal";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { ApiService } from "./api.service";
import {
  BehaviorSubject,
  forkJoin,
  map,
  mergeMap,
  Observable,
  of,
  share,
  Subject,
  switchMap,
  tap,
} from "rxjs";
import { MatSnackBar } from "@angular/material/snack-bar";
import { saveAs } from "file-saver";
import {
  SearchCriteriaRequest,
  SearchResponse,
} from "../pages/home/home.model";

@Injectable({
  providedIn: "root",
})
export class SearchService extends ApiService {
  private _url = this.apiUrl + "/search";

  private _loadingSubject = new BehaviorSubject<boolean>(false);

  private _searchSubject = new BehaviorSubject<any>(false);
  get dataSearch$() {
    return this._searchSubject.asObservable();
  }

  private _searchHistorySubject = new BehaviorSubject<any>(null);
  get searchHistory$() {
    return this._searchHistorySubject.asObservable();
  }

  private _quicksearchSubject = new BehaviorSubject<any>(false);
  get quicksearchData$() {
    return this._searchSubject.asObservable();
  }

  private data: SearchResponse;

  public get isLoading$() {
    return this._loadingSubject.asObservable();
  }

  private _componentForActions = new BehaviorSubject<ComponentPortal<any>>(
    null
  );
  public get componentForActions$() {
    return this._componentForActions.asObservable();
  }

  constructor(http: HttpClient, snackbar: MatSnackBar) {
    super(http, snackbar);
  }

  id(id: number) {
    return this.http
      .get(this._url + "/id?" + id)
      .pipe(this.handleResponse(this));
  }

  getbyuser() {
    return this.http.get(this._url + "/getbyuser").pipe(
      this.handleResponse(this),
      map((result) => {
        // console.log('searchs', result);
        const searchs = result.searchs;
        if (searchs && searchs.length > 0) {
          return searchs;
        } else {
          return [];
        }
      }),
      tap((data) => this._searchHistorySubject.next(data))
    );
  }

  getbyid(searchId) {
    return this.http
      .get(this._url + "/getbyid?" + searchId)
      .pipe(this.handleResponse(this));
  }

  quicksearch() {
    if (this._quicksearchSubject.value) {
      return this.http
        .post(this._url + "/quicksearch", {
          criteria: this._quicksearchSubject.value,
        })
        .pipe(
          this.handleResponse(this),
          tap((data) => this._searchSubject.next(data))
        );
    } else {
      return of(null);
    }
  }

  addQuickSearchData(data) {
    this._quicksearchSubject.next(data);
  }

  search(data) {
    return this.http
      .post(this._url, { search: data })
      .pipe(this.handleResponse(this));
  }

  images(searchid) {
    return this.http
      .get(this._url + "/images?" + searchid)
      .pipe(this.handleResponse(this), this.withSnackbarSuccess());
  }

  download(data) {
    return this.http
      .post(this._url + "/download", data)
      .pipe(this.handleResponse(this), this.withSnackbarSuccess());
  }

  update(data) {
    return this.http.post(this._url + "/update", { search: data }).pipe(
      this.handleResponse(this),
      this.withSnackbarSuccess(),
      tap(() => this.getbyuser().subscribe())
    );
  }

  setActionsComponent(componentPortal: ComponentPortal<any>) {
    this._componentForActions.next(componentPortal);
  }

  delete(id): Observable<boolean> {
    return this.http.delete(this._url + "?" + id).pipe(
      this.handleResponse(this),
      this.withSnackbarSuccess(),
      tap(() => this.getbyuser().subscribe())
    );
  }
}
